/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable camelcase */
import { TableCell, TableRow } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import React from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Table from "../../../components/common/new/Table/Table";
import tableStyle from "../../../theme/styles/table";
import EyeIcon from "../../../assets/svg/Eye";
import styles from "./GraduationTable.styles";
import Typography from "../../../components/common/new/Typography/Typography";
import InputField from "../../../components/common/new/InputField/InputField";
import {
  FDivisionColumns,
  columns,
  divisionColumns,
  graduationColumns,
} from "../utils";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { getOptions } from "../../../utils";
import { getSubDivisionDisplayName } from "../../../utils/helper";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const SHOW_NAME_DIVISION_IDS = [3];

const SUB_DIVISION_IDS = [56, 11];
const DIVISION_IDS = [52, 53];

const defaultSubDivision = [{ name: "STUDENT", subDivisionId: 58 }];

const getRows = ({
  searchData,
  onSelectMember,
  // onSelectMemberForTransfer,
  // hasPermission,
  // onMemberStatusToggle,
  selectedItems,
  // toggleItemSelection,
  // selectAll,
  handleChange,
  isDivision,
  onChangeInput,
  selectionHandler,
  inductionDate,
  memberName,
  university,
  universityVal,
  setUniversityVal,
  setMethod,
  setSubDivision,
  subDivision,
  editCollegeName,
  setEditCollegeName,
  isGraduation,
  selectedDivision,
}) =>
  searchData?.map((memberInfo, index) => {
    const isSelected = selectedItems?.some(
      (item) => item.memberId === memberInfo.memberId
    );
    const showNameInput =
      SHOW_NAME_DIVISION_IDS.includes(memberInfo.divisionId) &&
      selectedDivision === "YWD_WD";
    const showDropDownInput =
      DIVISION_IDS.includes(memberInfo.divisionId) &&
      SUB_DIVISION_IDS.includes(memberInfo.subdivisionId);

    console.log("isSelected", isSelected);

    return (
      <TableRow style={tableStyle.tableRow} key={index}>
        <TableCell
          style={{
            ...tabelCellWidth.medium,
          }}
        >
          <Checkbox
            sx={{
              marginLeft: "-12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            checked={selectedItems?.some(
              (item) => item.memberId === memberInfo.memberId
            )}
            onChange={(e) =>
              selectionHandler(
                e.target.checked,
                memberInfo.memberId,
                memberInfo.fullName
              )
            }
          />
        </TableCell>
        <TableCell
          style={
            isDivision && showNameInput
              ? { maxWidth: "8rem" }
              : { ...tabelCellWidth.small }
          }
        >
          {isDivision === true && showNameInput ? (
            <InputField
              label="Member Name"
              name="fullName"
              value={memberInfo?.fullName || memberName}
              onChange={(e) => {
                onChangeInput(e, memberInfo?.memberId, memberInfo?.fullName);
              }}
              style={{}}
              disabled={!isSelected}
            />
          ) : (
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.fullName ?? "NA"}
            </Typography>
          )}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.medium }}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.addressLine1 ?? "NA"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.small }}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.mobileNumber ?? "NA"}
            </Typography>{" "}
            <br />
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.emailId ?? "NA"}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={{ maxWidth: "11rem" }}>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {`${memberInfo?.areaName ?? "NA"} / ${
                memberInfo?.clusterName ?? "NA"
              } / ${memberInfo?.zoneName ?? "NA"} / ${
                memberInfo?.regionName ?? "NA"
              } / ${memberInfo?.chapterName ?? "NA"} / ${
                memberInfo?.districtName ?? "NA"
              } / ${memberInfo?.blockName}`}
            </Typography>{" "}
          </div>
        </TableCell>
        {showDropDownInput && isDivision === true && (
          <>
            <TableCell style={{ maxWidth: "9rem" }}>
              <AutoCompleteDropdown
                getOptionLabel={(option) => getSubDivisionDisplayName(option.name)}
                name="subDivisionId"
                options={getOptions(defaultSubDivision, "subDivisionId")}
                value={subDivision[index] || ""}
                label="Sub Division"
                onChange={(selectedValue) => {
                  const updatedValues = [...subDivision];
                  updatedValues[index] = selectedValue
                    ? selectedValue.value
                    : "";
                  setSubDivision(updatedValues);

                  setMethod((prevMethod) =>
                    prevMethod.map((item) =>
                      item.memberId === memberInfo.memberId
                        ? {
                            ...item,
                            subdivisionId: selectedValue?.value ?? "",
                          }
                        : item
                    )
                  );
                }}
                style={{ width: "8rem" }}
                disabled={!isSelected}
              />
            </TableCell>
            <TableCell style={{ maxWidth: "9.5rem" }}>
              <AutoCompleteDropdown
                getOptionLabel={(option) => option.name}
                name="universityId"
                options={getOptions(university, "id")}
                value={universityVal[index] || ""}
                label="University"
                onChange={(selectedValue) => {
                  const updatedValues = [...universityVal];
                  updatedValues[index] = selectedValue
                    ? selectedValue.value
                    : ""; // Update the value for the specific row
                  setUniversityVal(updatedValues);
                  setMethod((prevMethod) =>
                    prevMethod.map((item) =>
                      item.memberId === memberInfo.memberId
                        ? {
                            ...item,
                            universityId: selectedValue?.value ?? "",
                          }
                        : item
                    )
                  );
                }}
                disabled={!isSelected}
              />
              <div style={{ marginTop: "1rem" }}>
                <InputField
                  label="College"
                  name="collegeName"
                  value={editCollegeName[index] || ""}
                  onChange={(e) => {
                    const updatedValues = [...editCollegeName];
                    updatedValues[index] = e.target.value;
                    setEditCollegeName(updatedValues);
                    setMethod((prevMethod) =>
                      prevMethod.map((item) =>
                        item.memberId === memberInfo.memberId
                          ? {
                              ...item,
                              collegeName: e.target?.value ?? "",
                            }
                          : item
                      )
                    );
                  }}
                  style={{}}
                  disabled={!isSelected}
                />
              </div>
            </TableCell>
          </>
        )}

        {isDivision !== true && (
          <TableCell style={{ maxWidth: "9.5rem" }}>
            <div>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  disabled={!isSelected}
                  name="inductionDate"
                  style={{ width: "126px" }}
                  inputFormat="DD/MM/YYYY"
                  showDateDisplay={false}
                  // minDate={new Date()}
                  value={inductionDate[index] || ""}
                  onChange={(newValue) =>
                    handleChange(newValue, index, memberInfo)
                  }
                  renderInput={(params) => <InputField {...params} />}
                />
              </LocalizationProvider>
            </div>
          </TableCell>
        )}
        {(isGraduation === true || isDivision !== true) && (
          <TableCell style={tabelCellWidth.tiny}>
            {" "}
            <div style={styles.actionButtons}>
              <EyeIcon
                style={{ ...styles.actionIcon, marginTop: "4px" }}
                onClick={() => onSelectMember(memberInfo)}
              />
            </div>
          </TableCell>
        )}
      </TableRow>
    );
  });

function GraduationTable({
  searchData,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  hasPermission,
  showStatusColumn,
  isDivision,
  isGraduation,
  selectionHandler,
  checkAllToggle,
  selectedItems,
  handleChange,
  inductionDate,
  onChangeInput,
  memberName,
  university,
  universityVal,
  setUniversityVal,
  setMethod,
  subDivision,
  setSubDivision,
  editCollegeName,
  setEditCollegeName,
  selectedDivision,
}) {
  const getSubDivision = searchData?.map((memberInfo) => {
    return memberInfo.subdivisionId;
  });
  const getDivision = searchData?.map((memberInfo) => {
    return memberInfo.divisionId;
  });

  console.log("223", [...getSubDivision]);
  const tableHeader = () => {
    if (isGraduation === true) {
      return graduationColumns;
    }
    if (isDivision === true) {
      return (getDivision.includes(52) && getSubDivision.includes(56)) ||
        (getDivision.includes(53) && getSubDivision.includes(11))
        ? FDivisionColumns
        : divisionColumns;
    }
    return columns;
  };

  return (
    <div style={styles.container}>
      <Table
        selectedItems
        scrollable
        checkAllToggle={checkAllToggle}
        columns={tableHeader()}
        rows={getRows({
          searchData,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          selectedItems,
          // toggleItemSelection,
          // selectAll,
          inductionDate,
          handleChange,
          isDivision,
          onChangeInput,
          isGraduation,
          selectionHandler,
          memberName,
          university,
          universityVal,
          setUniversityVal,
          setMethod,
          subDivision,
          setSubDivision,
          editCollegeName,
          setEditCollegeName,
          selectedDivision,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default GraduationTable;
